import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import errorImg from "../../assets/error.png";
import { EXPCONFIG_FAST } from "@/common-components-src/const/point";
export interface pointParamsType {
  expoID: string;
  expoParam: any;
  refreshPoint: () => void;
}

interface errorPageProps {
  pointParams?: pointParamsType;
}

const errorPage: React.FC<errorPageProps> = observer(({ pointParams }) => {
  const { t } = useTranslation();
  const { expoID, expoParam, refreshPoint } = pointParams || {};

  const handleRefresh = () => {
    refreshPoint && refreshPoint();
    window.location.reload();
  };

  return (
    <div className={styles.wrap}>
      <img src={errorImg.src} alt="error" />
      <div>{t("order.orderList.errorPage.tip")}</div>
      <div
        className={styles.try_btn}
        onClick={handleRefresh}
        exptag={"exp|" + expoID}
        data-exptag-config={EXPCONFIG_FAST}
        data-exptag-json-param={JSON.stringify(expoParam)}
      >
        {t("order.orderList.errorPage.btnTip")}
      </div>
    </div>
  );
});

export default errorPage;
